import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import Overview from "@/pages/home/components/Overview";
import CoreContent from "@/pages/home/components/CoreContent";
import VersionTabs from "@/pages/home/components/VersionTabs";
import Quality from "@/pages/home/components/Quality";
import Structure from "@/pages/home/components/Structure";
import Faq from "@/pages/home/components/Faq";
import Guide from "@/pages/home/components/Guide";
import Related from "@/pages/home/components/Related";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteNav />
      <main className="flex-1">
        <Hero />
        <Overview />
        <CoreContent />
        <VersionTabs />
        <Quality />
        <Structure />
        <Faq />
        <Guide />
        <Related />
      </main>
      <SiteFooter />
    </div>
  );
}